export default __webpack_public_path__ + "static/media/auth-screens.7992f768.png";